import { PageFrame } from "../../components/page_frame";
import { RawInventoryHealthContainer } from "./container";

export default function RawInventoryHealthPage() {
  return (
    <PageFrame>
      <RawInventoryHealthContainer />
    </PageFrame>
  );
}


